<script>
  import { afterUpdate, onMount } from "svelte"

  export let dimensions = {}
  export let coordinate = ""
  export let autoCropDetails = {}

  let isDragging = false

  let resizeItems = ["top-left", "top-right", "bottom-left", "bottom-right"]

  let cropWidth
  let cropHeight

  // let MIN_WIDTH = 296
  // let MIN_HEIGHT = 164
  // let MAX_WIDTH = 592
  // let MAX_HEIGHT = 205

  let MIN_HEIGHT = 100
  let MIN_WIDTH = 100
  // let MIN_WIDTH = (MIN_HEIGHT * 4) / 3

  let activeResizer = null
  let cropElement
  /**
   * @type {HTMLCanvasElement}
   */
  let canvas

  onMount(async () => {
    try {
      // console.log({ dimensions })
      let scaleX = dimensions.clientWidth / dimensions.width
      let scaleY = dimensions.clientHeight / dimensions.height

      MIN_WIDTH = MIN_WIDTH * scaleX
      MIN_HEIGHT = MIN_HEIGHT * scaleY

      cropHeight = Math.max(scaleX * 100, MIN_HEIGHT)
      cropWidth = Math.max(scaleY * 100, MIN_WIDTH)

      if (Object.keys(autoCropDetails).length && !autoCropDetails.isModified) {
        cropHeight = autoCropDetails.height * scaleY
        cropWidth = autoCropDetails.width * scaleX
        cropElement.style.left = `${autoCropDetails.paddedMinX * scaleX}px`
        cropElement.style.top = `${autoCropDetails.paddedMinY * scaleY}px`
        autoCropDetails.isModified = true
      }

      // console.log({ MIN_WIDTH, MIN_HEIGHT, MAX_HEIGHT, MAX_WIDTH })

      // console.log(MAX_HEIGHT, dimensions.clientHeight, dimensions.clientHeight * scaleY)

      // MAX_WIDTH = MAX_WIDTH > dimensions.clientWidth ? dimensions.clientWidth : MAX_WIDTH
      // MAX_HEIGHT = MAX_HEIGHT > dimensions.clientHeight ? dimensions.clientHeight : MAX_HEIGHT

      // MAX_WIDTH = MAX_WIDTH > dimensions.clientWidth ? dimensions.width * scaleX : MAX_WIDTH
      // MAX_HEIGHT = MAX_HEIGHT > dimensions.clientHeight ? dimensions.height * scaleY : MAX_HEIGHT

      // cropHeight = Math.max(scaleX * 100, MIN_HEIGHT, MAX_HEIGHT)
      // cropWidth = Math.max(scaleY * 100, MIN_WIDTH, MAX_WIDTH)

      // console.log({ cropHeight, cropWidth, MIN_WIDTH, MIN_HEIGHT, MAX_HEIGHT, MAX_WIDTH })
      // console.log({ scaleX, scaleY })

      setTimeout(async () => {
        if (!coordinate) assignCoordinate()
        await drawOverlay()
      }, 1)
    } catch (error) {
      console.error(error)
    }
  })

  const drawOverlay = async () => {
    try {
      /**
       * @type {CanvasRenderingContext2D}
       */
      const ctx = canvas.getContext("2d")

      canvas.width = parseFloat(getComputedStyle(canvas.parentElement).width)
      canvas.height = parseFloat(getComputedStyle(canvas.parentElement).height)

      ctx.fillStyle = "rgb(0, 0, 0, 0.5)"

      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const cropLeft = parseFloat(getComputedStyle(cropElement).left)
      const cropTop = parseFloat(getComputedStyle(cropElement).top)

      // Subtracting 2px for eliminating border
      ctx.clearRect(cropLeft, cropTop, cropWidth - 2, cropHeight - 2)
    } catch (error) {
      throw error
    }
  }

  afterUpdate(async () => {
    if (cropElement) await drawOverlay()
  })

  const assignCoordinate = () => {
    try {
      if (!cropElement) return

      const { x, y } = getPosition()

      let yRatio = dimensions.clientWidth / dimensions.width
      let xRatio = dimensions.clientHeight / dimensions.height

      let cropElemWidth = parseFloat(getComputedStyle(cropElement).width)
      let cropElemHeight = parseFloat(getComputedStyle(cropElement).height)

      // console.log(cropElemWidth, cropElemHeight)

      let x1 = Math.floor(x / xRatio)
      let y1 = Math.floor(y / yRatio)
      let x2 = Math.round(cropElemWidth / xRatio)
      let y2 = Math.round(cropElemHeight / yRatio)

      coordinate = `${x1}, ${y1}, ${x2}, ${y2}`

      // console.log("coordinate sign resizer", coordinate)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Add Signer (Signature Crop area)\nEVENT: Error occured during coordinate assignment"
      notify.danger(error, info)
    }
  }

  const getPosition = () => {
    try {
      let parentElement = cropElement.parentElement
      let offsetX = cropElement.getBoundingClientRect().left - parentElement.getBoundingClientRect().left
      let offsetY = cropElement.getBoundingClientRect().top - parentElement.getBoundingClientRect().top

      if (offsetX < 0) offsetX = 0
      if (offsetY < 0) offsetY = 0

      return { x: Math.floor(offsetX), y: Math.floor(offsetY) }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Add Signer (Signature Crop area)\nEVENT: Error occured during coordinate calculation"
      notify.danger(error, info)
    }
  }

  const cropDetails = {
    width: "",
    height: "",
    mousePosition: {
      x: "",
      y: "",
    },
    position: {
      x: "",
      y: "",
    },
  }

  const mouseDown = (e, resizer) => {
    isDragging = true
    activeResizer = resizer

    // Store initial position and dimensions
    const { x, y } = getPosition()

    // console.log(cropHeight, cropElement.clientHeight)

    cropDetails.width = parseFloat(getComputedStyle(cropElement).width)
    cropDetails.height = parseFloat(getComputedStyle(cropElement).height)
    cropDetails.mousePosition.x = e.pageX
    cropDetails.mousePosition.y = e.pageY
    cropDetails.position.x = x
    cropDetails.position.y = y

    window.addEventListener("mouseup", mouseUp)
    window.addEventListener("mousemove", mouseMove)
  }

  /**
   * @param {MouseEvent}  event
   */
  const mouseMove = (e) => {
    if (!isDragging || !activeResizer) return

    // console.log("mousemove hits", activeResizer)

    const deltaX = e.pageX - cropDetails.mousePosition.x
    const deltaY = e.pageY - cropDetails.mousePosition.y

    let width = cropDetails.width
    let height = cropDetails.height
    let newLeft = cropDetails.position.x
    let newTop = cropDetails.position.y

    if (activeResizer.includes("bottom-right")) {
      width += deltaX
      height += deltaY
    } else if (activeResizer.includes("bottom-left")) {
      width -= deltaX
      height += deltaY
      newLeft += deltaX
    } else if (activeResizer.includes("top-right")) {
      width += deltaX
      height -= deltaY
      newTop += deltaY
    } else {
      height -= deltaY
      width -= deltaX
      newLeft += cropDetails.width - width
      newTop += cropDetails.height - height
    }

    const prevWidth = width
    const prevHeight = height

    if (height < MIN_HEIGHT) height = MIN_HEIGHT
    if (width < MIN_WIDTH) width = MIN_WIDTH

    if (height > dimensions.clientHeight) height = dimensions.clientHeight
    if (width > dimensions.clientWidth) width = dimensions.clientWidth

    if (newLeft < 0 || newTop < 0) return

    const parent = cropElement.parentElement
    let parentWidth = parseFloat(getComputedStyle(parent).width)
    let parentHeight = parseFloat(getComputedStyle(parent).height)

    if (newLeft + width > parentWidth || newTop + height > parentHeight) return

    cropWidth = width
    cropHeight = height
    if (prevWidth == width && activeResizer.includes("left")) cropElement.style.left = `${newLeft}px`
    if (prevHeight == height && activeResizer.includes("top")) cropElement.style.top = `${newTop}px`
  }

  const mouseUp = () => {
    isDragging = false
    activeResizer = null
    assignCoordinate()
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div bind:this={cropElement} on:mousemove on:mousedown on:mouseup on:mouseleave id="cropSignImg" style="height:{cropHeight}px;width:{cropWidth}px;" class="absolute bottom-0 left-0 z-10 cursor-all-scroll select-none border-2 border-red-500 bg-transparent text-[0.6em] font-bold">
  <!-- <div bind:this={cropElement} on:mousemove on:mousedown on:mouseup on:mouseleave id="cropSignImg" style="height:{cropHeight}px;width:{cropWidth}px;" class="absolute bottom-0 left-0 z-10 cursor-all-scroll select-none border-2 border-red-500 bg-[#497fe1]/10 text-[0.6em] font-bold"> -->
  {#each resizeItems as item}
    <div
      on:mousedown|preventDefault|stopPropagation={(e) => {
        mouseDown(e, item)
      }}
      class="absolute {item} pointer-events-auto select-auto rounded-full hover:scale-125"
    >
      <svg width="6" height="6">
        <circle cx="3" cy="3" r="3" fill="#ef4444" />
      </svg>
    </div>
  {/each}
</div>

<canvas bind:this={canvas} class="absolute inset-0 h-full w-full" />

<style lang="postcss">
  .resizers {
    @apply box-border h-full w-full border-[3px] border-red-500;
  }
  .resizer {
    @apply absolute z-10 h-3 w-3 border-[3px] border-red-500 bg-white;
  }
  .top-left {
    @apply left-0 top-0 -translate-y-1/2 -translate-x-1/2 cursor-nwse-resize;
  }
  .top-right {
    @apply right-0 top-0 -translate-y-1/2 translate-x-1/2 cursor-nesw-resize;
  }
  .bottom-left {
    @apply left-0 bottom-0 translate-y-1/2 -translate-x-1/2 cursor-nesw-resize;
  }
  .bottom-right {
    @apply right-0 bottom-0 translate-y-1/2 translate-x-1/2 cursor-nwse-resize;
  }
</style>
